import React, { PropsWithChildren } from 'react';
import {
  FlexStyle,
  StyleProp,
  TouchableOpacity,
  TouchableOpacityProps,
  View,
  ViewStyle,
} from 'react-native';

import { flex, minHeight, minWidth, opacity } from '../../style-utils';
import { Icon, IconProps } from '../icon/icon';

export type IconButtonProps = PropsWithChildren<
  IconProps & TouchableOpacityProps
> & {
  titleAlignement?: 'top' | 'right' | 'bottom' | 'left';
  iconStyle?: StyleProp<ViewStyle>;
};

export const IconButton = ({
  size = 24,
  name,
  color,
  type,
  disabled,
  onPress,
  style,
  children,
  titleAlignement = 'right',
  iconStyle,
  ...props
}: IconButtonProps) => {
  const { flexDirection, ...textMargin } = getPlacementStyles(titleAlignement);
  return (
    <TouchableOpacity
      style={[
        minWidth(size),
        minHeight(size),
        disabled ? opacity(0.5) : opacity(1),
        style,
      ]}
      onPress={onPress}
      disabled={disabled}
      {...props}
    >
      <View style={[flex('align-items-center'), { flexDirection }]}>
        <Icon
          size={size}
          color={color}
          name={name}
          type={type}
          style={[textMargin, iconStyle]}
        />
        {children}
      </View>
    </TouchableOpacity>
  );
};

const getPlacementStyles = (
  titleAlignement: string
): {
  flexDirection: FlexStyle['flexDirection'];
  marginLeft?: number;
  marginBottom?: number;
  marginRight?: number;
  marginTop?: number;
} => {
  switch (titleAlignement) {
    case 'top':
      return { flexDirection: 'column-reverse', marginTop: 2 };
    case 'right':
      return { flexDirection: 'row', marginRight: 8 };
    case 'left':
      return { flexDirection: 'row-reverse', marginLeft: 8 };
    case 'bottom':
    default:
      return { flexDirection: 'column', marginBottom: 2 };
  }
};
